var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63281 13.5219L10.5818 9.98017C11.1059 8.02413 9.94513 6.01356 7.98909 5.48944C6.03305 4.96532 4.02248 6.12612 3.49836 8.08216L1.12585 16.9365C0.601729 18.8925 1.76253 20.9031 3.71857 21.4272C4.6168 21.6679 5.52652 21.5533 6.29852 21.1695C6.77229 20.934 7.1942 20.5971 7.52975 20.1788M7.04008 9.03117L6.09108 12.5729C5.56696 14.5289 6.72776 16.5395 8.68381 17.0636C10.6398 17.5877 12.6504 16.4269 13.1745 14.4709L15.547 5.61658C16.0712 3.66054 14.9104 1.64997 12.9543 1.12585C12.0561 0.88517 11.1464 0.99979 10.3744 1.38356C9.9006 1.61907 9.47869 1.95595 9.14314 2.37429",
    stroke: "#2D264B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipIcon);
export default __webpack_public_path__ + "static/media/clipIcon.e0910b9dca933b354e19bfe2c080a614.svg";
export { ForwardRef as ReactComponent };